import { FracaoDto } from "src/app/pagamento/models/fracao-dto";

export const FRACAO_DTO: FracaoDto[] = [

  {
    numeroDocumento: "A",
    sequencialFracao: 0,
    valor: 1,
    receita: {
      receitaCodigo: 2,
      receitaNome: "B",
      extensaoReceitaCodigo: 3,
      extensaoReceitaTexto: "C",
    },
    tipoFracao: {
      codigo: 4,
      descricao: "D",
    },
    valorSaldo: 5,
    versao: 6,
  },
  {
    numeroDocumento: "E",
    sequencialFracao: 7,
    valor: 8,
    receita: {
      receitaCodigo: 9,
      receitaNome: "F",
      extensaoReceitaCodigo: 10,
      extensaoReceitaTexto: "G",
    },
    tipoFracao: {
      codigo: 11,
      descricao: "H",
    },
    valorSaldo: 12,
    versao: 13,
  },
  {
    numeroDocumento: "I",
    sequencialFracao: 14,
    valor: 15,
    receita: {
      receitaCodigo: 16,
      receitaNome: "J",
      extensaoReceitaCodigo: 17,
      extensaoReceitaTexto: "K",
    },
    tipoFracao: {
      codigo: 18,
      descricao: "L",
    },
    valorSaldo: 19,
    versao: 20,
  },
];